import React from "react";

import {
  AddContactIcon,
  FilterAddContactTypesIcon,
  FilterProspectIcon,
  FilterTeamMemberIcon,
} from "../common/Icon";

const FilterModel = ({ setFilterModel }) => {
  return (
    <>
      <div
        onClick={() => {
          setFilterModel(false);
        }}
        className="overflow-hidden">
        <div className="w-[188px] bg-white text-center  rounded-xl py-4 px-3">
          <div>
            <button className="flex gap-2 items-center text-sm font-normal text-black border-b border-[#F2F2F2]  hover:bg-[#00000026]/[7%] w-full  py-2 duration-300 px-1">
              <span>
                <AddContactIcon />
              </span>
              Customer
            </button>

            <button className="flex gap-2 items-center text-sm font-normal text-black border-b border-[#F2F2F2]  hover:bg-[#00000026]/[7%] w-full  py-2 duration-300 px-1">
              <span>
                <FilterProspectIcon />
              </span>
              Prospect
            </button>

            <button className="flex gap-2 items-center text-sm font-normal text-black border-b border-[#F2F2F2]  hover:bg-[#00000026]/[7%] w-full  py-2 duration-300 px-1">
              <span>
                <FilterTeamMemberIcon />
              </span>
              Team Member
            </button>

            <button className="flex gap-2 items-center text-sm font-normal text-black  hover:bg-[#00000026]/[7%] w-full  py-2 duration-300 px-1">
              <span>
                <FilterAddContactTypesIcon />
              </span>
              Add Contact Types
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterModel;
